import { apiClient } from "@api/apiClient";

import type { RegulatoryClassificationData } from "./regulatoryClassification.interface";

const API_ENDPOINT = "/edb/internal/regulatory-label/filter/classification";

export const regulatoryClassificationApi = {
  getClassificationFilterData: async () => {
    const { data } = await apiClient.get<RegulatoryClassificationData>(
      API_ENDPOINT,
    );

    return data;
  },
};
